import React from "react";

import { Component } from "../../../../commons/types/component";
import cn from "../../libs/class-name";
import Headline from "../Headline/Headline";

type Layout =
  | {
      type: "fixed";
      columnCount?: number;
    }
  | {
      type: "responsive";
      minItemWidth: number;
      minColumnCount?: number;
    };

interface Props extends Component {
  title?: string;
  children: React.ReactNode;
  justifyContent?: "normal" | "start";
  layout?: Layout;
}

const FilterModalValues = ({
  classNames = [],
  title = "",
  children,
  justifyContent = "normal",
  layout = { type: "fixed" }
}: Props) => {
  const childrenCount = React.Children.count(children);
  const isResponsive = layout.type === "responsive";
  const minItemWidth = isResponsive ? layout.minItemWidth : undefined;
  const minColumnCount = isResponsive ? (layout.minColumnCount ?? 3) : 3;

  // A maximum of 3 columns, otherwise the columnCount should be equal to childrenCount
  const columnCount = !isResponsive && layout.columnCount ? layout.columnCount : childrenCount >= 3 ? 3 : childrenCount;

  const modifiers = {
    [`justify-content-${justifyContent}`]: justifyContent,
    responsive: isResponsive,
    [`columns-${columnCount}`]: !isResponsive && columnCount
  };

  return (
    <div className={cn("FilterModalValues", [modifiers], classNames)}>
      {!!title && (
        <div className="FilterModalValues__title">
          <Headline kind="minor">{title}</Headline>
        </div>
      )}

      <div
        className="FilterModalValues__content"
        style={
          isResponsive
            ? ({
                "--min-item-width": `${minItemWidth}px`,
                "--min-column-count": minColumnCount
              } as React.CSSProperties)
            : undefined
        }
      >
        {children}
      </div>
    </div>
  );
};

export default FilterModalValues;
